<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/lululemon/products/*', { eager: true });

useHead({});

const products = [
	{
		title: "Men's License to Train Hoodie",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonmens-license-to-train-hoodie.png"].default
	},
	{
		title: "Men's Evolution Short-Sleeve Polo Shirt",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonmens-evolution-shortsleeve-polo-shirt.png"].default
	},
	{
		title: "Metal Vent Tech Short-Sleeve Shirt",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonmetal-vent-tech-shortsleeve-shirt.png"].default
	},
	{
		title: "Women's Scuba Oversized Half-Zip Hoodie",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonwomens-scuba-oversized-halfzip-hoodie.png"].default
	},
	{
		title: "Women's Swiftly Tech Short-Sleeve Shirt 2.0",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonwomens-swiftly-tech-shortsleeve-shirt-20.png"].default
	},
	{
		title: "Women's Swiftly Tech Long-Sleeve Shirt 2.0",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonwomens-swiftly-tech-longsleeve-shirt-20.png"].default
	},
	{
		title: "Men's Soft Jersey Half Zip",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonmens-soft-jersey-half-zip.png"].default
	},
	{
		title: "Women's Quick-Dry Short-Sleeve Polo Shirt",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonwomens-quickdry-shortsleeve-polo-shirt.png"].default
	},
	{
		title: "Men's Steady State Crew",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonmens-steady-state-crew.png"].default
	},
	{
		title: "Women's Perfectly Oversized Crew",
		src: imagesGlob["../../images/brands/lululemon/products/swaggerproductpagewebsiteholidaykitslululemonwomens-perfectly-oversized-crew.png"].default
	},
]
</script>

<template lang="pug">
.page.page--brand.lululemon
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/lululemon/logo.png')
				h1 Custom Lululemon
			.image
				img(src='@static/images/brands/lululemon/hero.jpg' alt='Women wearing lululemon loungewear and leggings, showcasing premium fabrics, comfort, and versatile lifestyle apparel for custom corporate gifts.')
	section.section.section--subhero
		.section__content
			.copy
				h3 BE ALL IN
				p Custom lululemon by Swagger blends sleek design, technical innovation, and all-day comfort to create gear that moves with you. Known for premium fabrics and performance-driven details, lululemon has redefined activewear, making pieces as versatile in the office as they are in the studio. Every item is designed with intention: to support movement, mindfulness, and modern living.

	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="lululemon")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/lululemon/banner.png' alt='Group of athletes running in lululemon activewear on a city street, highlighting performance apparel for movement, training, and corporate gifting.')
			.section__content
				.copy
					h2 GIFTING THAT MOVES PEOPLE
					p Beyond apparel, lululemon invests in holistic wellbeing through the lululemon Centre for Social Impact, expanding access to movement, mindfulness, and community worldwide. Many of their products also feature recycled and responsibly sourced materials, reflecting a mindful approach to design and impact. As a brand committed to elevating both performance and people, gifting lululemon means offering products that inspire and empower.
		
		section.section.section--foot
			.bg
			.section__content

</template>

<style></style>